import React from "react";

export const Impressum = (): React.JSX.Element => {
  return (
    <div>
      <div className="pt-20"></div>
      <h2 className="text-4xl font-bold mb-4">Impressum</h2>
          
      <div className="mx-auto mt-8 p-6 bg-white rounded-md space-y-10" data-aos="fade-right">
        {/* Angaben gemäß § 5 TMG */}
        <section>
          <h2 className="text-3xl font-semibold mb-4">
            Angaben gemäß § 5 TMG
          </h2>
          <div className="bg-blue-50 p-4 rounded-lg mb-4">
            <p className="text-sm text-blue-800">
              <strong>Hinweis:</strong> Die folgenden Angaben sind gemäß § 5 Telemediengesetz (TMG) erforderlich.
            </p>
          </div>
              
          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-medium text-gray-700 mb-2">Vereinsname</h3>
              <p className="text-gray-700">
                Koptische Gemeinde St. Georg e.V.
              </p>
            </div>
            
            <div>
              <h3 className="text-lg font-medium text-gray-700 mb-2">Vertreten durch</h3>
              <p className="text-gray-700">
                Vorstand, Dr. Sameh Iskander
              </p>
            </div>
            
            <div>
              <h3 className="text-lg font-medium text-gray-700 mb-2">Anschrift</h3>
              <div className="text-gray-700 space-y-1">
                <p>Hechtstraße 78</p>
                <p>01127, Dresden</p>
                <p>Deutschland</p>
              </div>
            </div>
            
            <div>
              <h3 className="text-lg font-medium text-gray-700 mb-2">Kontakt</h3>
              <div className="text-gray-700 space-y-1">
                <p>Telefon: +49 178 1581273</p>
                <p>E-Mail: dr.iskander@koptische-gemeinde.de</p>
              </div>
            </div>
          </div>
            </section>

        {/* Registereintrag */}
        <section>
          <h2 className="text-3xl font-semibold mb-4">
            Registereintrag
          </h2>
          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-medium text-gray-700 mb-2">Eintragung im Vereinsregister</h3>
              <p className="text-gray-700">
                Registergericht: Amtsgericht Dresden
              </p>
              <p className="text-gray-700">
                Registernummer: 5821
              </p>
            </div>
            
            
          </div>
        </section>

        {/* Verantwortlich für den Inhalt */}
        <section>
          <h2 className="text-3xl font-semibold mb-4">
            Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
          </h2>
          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-medium text-gray-700 mb-2">Redaktionell verantwortlich</h3>
              <p className="text-gray-700">
                Dr. Sameh Iskander
              </p>
              <div className="text-gray-700 space-y-1 mt-2">
                <p>Hechtstraße 78</p>
                <p>01127, Dresden</p>
              </div>
            </div>
          </div>
        </section>

        {/* Haftungsausschluss */}
        <section>
          <h2 className="text-3xl font-semibold mb-4">
            Haftungsausschluss
          </h2>
          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-medium text-gray-700 mb-2">Haftung für Inhalte</h3>
              <p className="text-gray-700">
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den 
                allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht 
                unter der Verpflichtung, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach 
                Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              </p>
            </div>
            
            <div>
              <h3 className="text-lg font-medium text-gray-700 mb-2">Haftung für Links</h3>
              <p className="text-gray-700">
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. 
                Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten 
                Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
              </p>
            </div>
            
            <div>
              <h3 className="text-lg font-medium text-gray-700 mb-2">Urheberrecht</h3>
              <p className="text-gray-700">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen 
                Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der 
                Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
            </div>
          </div>
        </section>

        {/* Datenschutz */}
        <section>
          <h2 className="text-3xl font-semibold mb-4">
            Datenschutz
          </h2>
          <div className="space-y-4">
            <p className="text-gray-700">
              Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf 
              unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder eMail-Adressen) erhoben werden, 
              erfolgt dies, soweit möglich, stets auf freiwilliger Basis.
            </p>
            <p className="text-gray-700">
              Weitere Informationen zum Datenschutz finden Sie in unserer 
              <a href="/datenschutz" className="text-blue-600 hover:text-blue-800 underline ml-1">
                Datenschutzerklärung
              </a>.
            </p>
          </div>
        </section>

        {/* Streitschlichtung */}
        <section>
          <h2 className="text-3xl font-semibold mb-4">
            Streitschlichtung
          </h2>
          <div className="space-y-4">
            <p className="text-gray-700">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" 
                 className="text-blue-600 hover:text-blue-800 underline ml-1">
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p className="text-gray-700">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </div>
        </section>
        
      </div>
    </div>
  );
};
